import React from 'react';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import ImportEncoderCsv from '../components/ImportEncoderCsv';

export default function ImportEncoderCsvPage() {
  return (
    <DashboardLayout>
      <ImportEncoderCsv />
    </DashboardLayout>
  );
}
